import React from 'react';
import { FormLabel, FormHelperText } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { InstantClientSelect } from '@/components/selects/ClientSelect';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { BROKER_GROUP_ID } from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { SEARCH_CLIENT_HELP_TEXT } from '@/utils/helperText';

// Shared client-search scaffold for the endorsement forms: sets the common clientId/clientName/
// brokerGroupId fields itself. onSelect/onClear are optional hooks for whatever
// extra reset behaviour a given form needs on top of that (policies context, a single policy field, etc).
const ClientSearchField = ({ disabled, onSelect, onClear }) => {
	const { values, setFieldValue } = useFormikContext();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	return (
		<>
			<FormLabel required>{'Search client name'}</FormLabel>
			<InstantClientSelect
				clientId={values.clientId}
				clientName={values.clientName}
				filterProspects={true}
				setClient={(newClient) => {
					console.log('Here is the selected client: ', newClient);
					if (newClient) {
						setFieldValue('clientId', newClient.id);
						setFieldValue('clientName', newClient.name);
						setFieldValue(
							BROKER_GROUP_ID,
							newClient.brokerGroupId ?? userDetails?.brokerGroupId,
						);
						onSelect?.(newClient);
					} else {
						setFieldValue('clientId', null);
						setFieldValue('clientName', '');
						setFieldValue(BROKER_GROUP_ID, userDetails?.brokerGroupId);
						onClear?.();
					}
				}}
				disabled={disabled}
			/>
			<FormHelperText>{SEARCH_CLIENT_HELP_TEXT}</FormHelperText>
		</>
	);
};

export default ClientSearchField;
